//import { rgbToHex } from "@material-ui/core";
//import { red } from "@material-ui/core/colors";
import React, { useState, useEffect } from "react";
import { Responsive as ResponsiveGridLayout } from "react-grid-layout";
import { withSize } from "react-sizeme";
import TopBar from "./TopBar";
import Widget from "./widget";
//import { Responsive, WidthProvider } from 'react-grid-layout';
const originalItems = ["a" , "b", "c", "d", "e", "f", "g", /*"h"*/, "i", "j","k","l","m","n",/*"o"*/,"p","r","s","t","u","v"];

const initialLayouts = { 
  lg: [
    { i: "a", x: 5, y: 92, w: 3, h: 93, minW: 2, maxW: 12, minH: 33, maxH: 2000 },
    { i: "b", x: 0, y: 194, w: 3, h: 38, minW: 2, maxW: 12, minH: 25, maxH: 1600 },
    { i: "c", x: 0, y: 0, w: 3, h: 46, minW: 2, maxW: 12, minH: 39, maxH: 1600 },
    { i: "d", x: 0, y: 46, w: 2, h: 58, minW: 2, maxW: 12, minH: 23, maxH: 1600 },
    { i: "e", x: 2, y: 46, w: 3, h: 137, minW: 2, maxW: 12, minH: 39, maxH: 1600 },
    { i: "f", x: 10, y: 0, w: 2, h: 57, minW: 2, maxW: 12, minH: 23, maxH: 1600 },
    { i: "g", x: 10, y: 57, w: 2, h: 51, minW: 2, maxW: 12, minH: 23, maxH: 1600 },
    { i: "i", x: 0, y: 104, w: 2, h: 30, minW: 2, maxW: 12, minH: 18, maxH: 1600 },
    { i: "j", x: 3, y: 183, w: 2, h: 75, minW: 2, maxW: 12, minH: 23, maxH: 1600 },
    { i: "k", x: 0, y: 232, w: 3, h: 27, minW: 2, maxW: 12, minH: 15, maxH: 1600 },
    { i: "l", x: 8, y: 0, w: 2, h: 92, minW: 2, maxW: 12, minH: 23, maxH: 1600 },
    { i: "p", x: 5, y: 0, w: 3, h: 92, minW: 2, maxW: 12, minH: 40, maxH: 1600 },
    { i: "r", x: 5, y: 185, w: 3, h: 83, minW: 2, maxW: 12, minH: 23, maxH: 1600 },
    { i: "s", x: 8, y: 222, w: 2, h: 46, minW: 2, maxW: 12, minH: 23, maxH: 1600 },
    { i: "t", x: 0, y: 134, w: 2, h: 60, minW: 2, maxW: 12, minH: 23, maxH: 1600 },
    { i: "u", x: 8, y: 108, w: 4, h: 114, minW: 2, maxW: 12, minH: 23, maxH: 1600 },
    { i: "v", x: 3, y: 0, w: 2, h: 46, minW: 2, maxW: 12, minH: 23, maxH: 1600 },
  ]
};



const initialLayoutsPrivate = { 
  lg: [
    { i: "a", x: 4, y: 0, w: 4, h: 78, minW: 2, maxW: 12, minH: 33,  maxH: 1600 },
    { i: "b", x: 8, y: 300, w: 4, h: 49, minW: 2, maxW: 12, minH: 28,  maxH: 1600 },
    { i: "c", x: 0, y: 100, w: 4, h: 67 ,minW: 2, maxW: 12, minH: 39,  maxH: 1600 },
    { i: "d", x: 0, y: 83, w: 3, h: 88 ,minW: 2, maxW: 12, minH: 23,  maxH: 1600 },
    { i: "e", x: 3, y: 0, w: 3, h: 208,minW: 2, maxW: 12, minH: 39,  maxH: 1600  },
    { i: "f", x: 6, y: 82, w: 2, h: 58, minW: 2, maxW: 12, minH: 23,  maxH: 1600 },
    { i: "g", x: 4, y: 0, w: 4, h: 53, minW: 2, maxW: 12, minH: 23,  maxH: 1600 },
    //{ i: "h", x: 6, y: 140, w: 4, h: 68, minW: 2, maxW: 12, minH: 23,  maxH: 1600},
    { i: "i", x: 4, y: 200, w: 4, h: 32, minW: 2, maxW: 12, minH: 18,  maxH: 1600},
    { i: "j", x: 10, y: 116, w: 2, h: 92, minW: 2, maxW: 12, minH: 23,  maxH: 1600},
    { i: "k", x: 0, y: 300, w: 4, h: 32, minW: 2, maxW: 12, minH: 15,  maxH: 1600},
    { i: "l", x: 0, y: 0, w: 4, h: 78, minW: 2, maxW: 12, minH: 23,  maxH: 1600},
    { i: "m", x: 5, y: 1000, w: 3, h: 27, minW:2, minH: 23, maxW: 12,  maxH: 1600},
    { i: "n", x: 0, y: 0, w: 3, h: 27, minW:2, minH: 23, maxW: 12,  maxH: 1600},
    { i: "p", x: 6, y: 0, w: 2, h: 82 ,minW: 2, maxW: 12, minH: 40,  maxH: 1600 },
    { i: "r", x: 0, y: 0, w: 3, h: 83, minW: 2, maxW: 12, minH: 23,  maxH: 1600},
    { i: "s", x: 6, y: 140, w: 4, h: 68, minW: 2, maxW: 12, minH: 23,  maxH: 1600},
    //{ i: "t", x: 8, y: 1200, w: 4, h: 32, minW: 2, maxW: 12, minH: 23,  maxH: 1600},
    { i: "u", x: 8, y: 0, w: 4, h: 116, minW: 2, maxW: 12, minH: 23,  maxH: 1600},
    { i: "v", x: 8, y: 0, w: 4, h: 78, minW: 2, maxW: 12, minH: 30,  maxH: 1600 }
  ]
};

const initialLayoutsMaterial= { 
  lg: [
    { i: "a", x: 4, y: 0, w: 4, h: 78, minW: 2, maxW: 12, minH: 33,  maxH: 1600 },
    { i: "b", x: 8, y: 0, w: 4, h: 48,  minW: 2, maxW: 12, minH: 28,  maxH: 1600 },
    { i: "c", x: 0, y: 200, w: 4, h: 56 , minW: 2, maxW: 12, minH: 39,  maxH: 1600 },
    { i: "d", x: 4, y: 200, w: 8, h: 42 , minW: 2, maxW: 12, minH: 23,  maxH: 1600 },
    { i: "e", x: 0, y: 300, w: 8, h: 58, minW: 2, maxW: 12, minH: 39,  maxH: 1600  },
    { i: "f", x: 0, y: 0, w: 4, h: 42, minW: 2, maxW: 12, minH: 23,  maxH: 1600 },
    { i: "g", x: 4, y: 0, w: 4, h: 53, minW: 2, maxW: 12, minH: 23,  maxH: 1600 },
    //{ i: "h", x: 8, y: 0, w: 4, h: 56 ,  minW: 2, maxW: 12, minH: 23,  maxH: 1600},
    { i: "i", x: 4, y: 200, w: 4, h: 44,  minW: 2, maxW: 12, minH: 18,  maxH: 1600},
    { i: "j", x: 8, y: 400, w: 4, h: 42, minW: 2, maxW: 12, minH: 23,  maxH: 1600},
    { i: "k", x: 8, y: 300, w: 4, h: 32,  minW: 2, maxW: 12, minH: 15,  maxH: 1600},
    { i: "l", x: 0, y: 0, w: 4, h: 78, minW: 2, maxW: 12, minH: 23,  maxH: 1600},
    { i: "m", x: 0, y: 500, w: 4, h: 40, minW:2, minH: 23, maxW: 12,  maxH: 1600},
    { i: "n", x: 5, y: 500, w: 3, h: 27, minW:2, minH: 23, maxW: 12,  maxH: 1600},
    { i: "p", x: 4, y: 200, w: 8, h: 42 , minW: 2, maxW: 12, minH: 40,  maxH: 1600 },
    { i: "r", x: 4, y: 200, w: 8, h: 42 , minW: 2, maxW: 12, minH: 40,  maxH: 1600 },
    { i: "s", x: 4, y: 200, w: 8, h: 42 , minW: 2, maxW: 12, minH: 40,  maxH: 1600 },
    { i: "t", x: 4, y: 200, w: 8, h: 42 , minW: 2, maxW: 12, minH: 40,  maxH: 1600 },
    { i: "u", x: 4, y: 200, w: 8, h: 42 , minW: 2, maxW: 12, minH: 40,  maxH: 1600 },
    { i: "v", x: 8, y: 0, w: 4, h: 78, minW: 2, maxW: 12, minH: 30,  maxH: 1600 },
  ]
};


const initialLayoutsProduct = { 
  lg: [
     { i: "a", x: 5, y: 92, w: 3, h: 93, minW: 2, maxW: 12, minH: 33, maxH: 2000 },
     { i: "b", x: 7, y: 0, w: 3, h: 49, minW: 2, maxW: 12, minH: 28, maxH: 1600 },
    { i: "c", x: 0, y: 0, w: 3, h: 49, minW: 2, maxW: 12, minH: 39, maxH: 1600 },
    { i: "d", x: 0, y: 46, w: 2, h: 58, minW: 2, maxW: 12, minH: 23, maxH: 1600 },
    { i: "e", x: 2, y: 46, w: 3, h: 137, minW: 2, maxW: 12, minH: 39, maxH: 1600 },
    { i: "f", x: 10, y: 0, w: 2, h: 57, minW: 2, maxW: 12, minH: 23, maxH: 1600 },
    { i: "g", x: 10, y: 0, w: 2, h: 41, minW: 2, maxW: 12, minH: 23, maxH: 1600 },
    //{ i: "h", x: 8, y: 0, w: 4, h: 56 ,  minW: 2, maxW: 12, minH: 23,  maxH: 1600},
    { i: "i", x: 3, y: 0, w: 2, h: 27, minW: 2, maxW: 12, minH: 18, maxH: 1600 },
    { i: "j", x: 3, y: 183, w: 2, h: 75, minW: 2, maxW: 12, minH: 23, maxH: 1600 },
    { i: "k", x: 3, y: 27, w: 2, h: 22, minW: 2, maxW: 12, minH: 15, maxH: 1600 },
    { i: "l", x: 8, y: 0, w: 2, h: 92, minW: 2, maxW: 12, minH: 23, maxH: 1600 },
    { i: "m", x: 0, y: 500, w: 4, h: 40, minW:2, minH: 23, maxW: 12,  maxH: 1600},
    { i: "n", x: 5, y: 500, w: 3, h: 27, minW:2, minH: 23, maxW: 12,  maxH: 1600},
    { i: "p", x: 5, y: 0, w: 3, h: 92, minW: 2, maxW: 12, minH: 40, maxH: 1600 },
    { i: "r", x: 5, y: 185, w: 3, h: 83, minW: 2, maxW: 12, minH: 23, maxH: 1600 },
    { i: "s", x: 8, y: 222, w: 2, h: 46, minW: 2, maxW: 12, minH: 23, maxH: 1600 },
    { i: "t", x: 5, y: 0, w: 2, h: 49, minW: 2, maxW: 12, minH: 23, maxH: 1600 },
    { i: "u", x: 8, y: 108, w: 4, h: 114, minW: 2, maxW: 12, minH: 23, maxH: 1600 },
    { i: "v", x: 3, y: 0, w: 2, h: 46, minW: 2, maxW: 12, minH: 23, maxH: 1600 },
  ]
};

const initialLayoutsAbout = { 
  lg: [
    { i: "a", x: 4, y: 0, w: 8, h: 56, minW: 2, maxW: 12, minH: 33,  maxH: 1600 },
    { i: "b", x: 8, y: 0, w: 4, h: 48, minW: 2, maxW: 12, minH: 28,  maxH: 1600 },
    { i: "c", x: 0, y: 200, w: 4, h: 56 , minW: 2, maxW: 12, minH: 39,  maxH: 1600 },
    { i: "d", x: 4, y: 200, w: 8, h: 42 , minW: 2, maxW: 12, minH: 23,  maxH: 1600 },
    { i: "e", x: 0, y: 300, w: 8, h: 58, minW: 2, maxW: 12, minH: 39,  maxH: 1600  },
    { i: "f", x: 0, y: 0, w: 4, h: 42, minW: 2, maxW: 12, minH: 23,  maxH: 1600 },
    { i: "g", x: 4, y: 0, w: 4, h: 53, minW: 2, maxW: 12, minH: 23,  maxH: 1600 },
    //{ i: "h", x: 0, y: 350, w: 4, h: 41 ,  minW: 2, maxW: 12, minH: 23,  maxH: 1600},
    { i: "i", x: 4, y: 200, w: 4, h: 44, minW: 2, maxW: 12, minH: 18,  maxH: 1600},
    { i: "j", x: 8, y: 400, w: 4, h: 42, minW: 2, maxW: 12, minH: 23,  maxH: 1600},
    { i: "k", x: 8, y: 300, w: 4, h: 32, minW: 2, maxW: 12, minH: 15,  maxH: 1600},
    { i: "l", x: 4, y: 400, w: 8, h: 33, minW: 2, maxW: 12, minH: 23,  maxH: 1600},
    { i: "m", x: 4, y: 500, w: 8, h: 47, minW:2, minH: 39, maxW: 12,  maxH: 1600},
    { i: "n", x: 0, y: 0, w: 4, h: 47, minW:2, minH: 39, maxW: 12,  maxH: 1600},
   // { i: "o", x: 0, y: 500, w: 12, h: 300, minW:2, minH: 39, maxW: 12,  maxH: 1600},
    { i: "p", x: 4, y: 200, w: 8, h: 42 , minW: 2, maxW: 12, minH: 40,  maxH: 1600 },
    { i: "r", x: 8, y: 1200, w: 4, h: 32, minW: 2, maxW: 12, minH: 23,  maxH: 1600},
    { i: "s", x: 8, y: 1200, w: 4, h: 32, minW: 2, maxW: 12, minH: 23,  maxH: 1600},
    { i: "t", x: 8, y: 1200, w: 4, h: 32, minW: 2, maxW: 12, minH: 23,  maxH: 1600},
    { i: "u", x: 8, y: 1200, w: 4, h: 32, minW: 2, maxW: 12, minH: 23,  maxH: 1600},
    { i: "v", x: 8, y: 1200, w: 4, h: 32, minW: 2, maxW: 12, minH: 23,  maxH: 1600}
     ]
};

const initialLayoutsPrivacy = { 
  lg: [
    { i: "a", x: 4, y: 0, w: 8, h: 56, minW: 2, maxW: 12, minH: 33,  maxH: 1600 },
    { i: "b", x: 8, y: 0, w: 4, h: 48, minW: 2, maxW: 12, minH: 28,  maxH: 1600 },
    { i: "c", x: 0, y: 200, w: 4, h: 56 , minW: 2, maxW: 12, minH: 39,  maxH: 1600 },
    { i: "d", x: 4, y: 200, w: 8, h: 42 , minW: 2, maxW: 12, minH: 23,  maxH: 1600 },
    { i: "e", x: 0, y: 300, w: 8, h: 58, minW: 2, maxW: 12, minH: 39,  maxH: 1600  },
    { i: "f", x: 0, y: 0, w: 4, h: 42, minW: 2, maxW: 12, minH: 23,  maxH: 1600 },
    { i: "g", x: 4, y: 0, w: 4, h: 53, minW: 2, maxW: 12, minH: 23,  maxH: 1600 },
   // { i: "h", x: 0, y: 350, w: 4, h: 41 ,  minW: 2, maxW: 12, minH: 23,  maxH: 1600},
    { i: "i", x: 4, y: 200, w: 4, h: 44, minW: 2, maxW: 12, minH: 18,  maxH: 1600},
    { i: "j", x: 8, y: 400, w: 4, h: 42, minW: 2, maxW: 12, minH: 23,  maxH: 1600},
    { i: "k", x: 8, y: 300, w: 4, h: 32, minW: 2, maxW: 12, minH: 15,  maxH: 1600},
    { i: "l", x: 4, y: 400, w: 8, h: 33, minW: 2, maxW: 12, minH: 23,  maxH: 1600},
    { i: "m", x: 4, y: 500, w: 8, h: 45, minW:2, minH: 39, maxW: 12,  maxH: 1600},
    { i: "n", x: 0, y: 500, w: 4, h: 45, minW:2, minH: 37, maxW: 12,  maxH: 1600},
    { i: "o", x: 0, y: 500, w: 12, h: 600, minW:2, minH: 39, maxW: 12,  maxH: 1600},
    { i: "p", x: 4, y: 200, w: 8, h: 42 , minW: 2, maxW: 12, minH: 40,  maxH: 1600 },
    { i: "r", x: 8, y: 1200, w: 4, h: 32, minW: 2, maxW: 12, minH: 23,  maxH: 1600},
    { i: "s", x: 8, y: 1200, w: 4, h: 32, minW: 2, maxW: 12, minH: 23,  maxH: 1600},
    { i: "t", x: 8, y: 1200, w: 4, h: 32, minW: 2, maxW: 12, minH: 23,  maxH: 1600},
    { i: "u", x: 8, y: 1200, w: 4, h: 32, minW: 2, maxW: 12, minH: 23,  maxH: 1600},
    { i: "v", x: 8, y: 1200, w: 4, h: 32, minW: 2, maxW: 12, minH: 23,  maxH: 1600}
  ]
};

function Content({ size: { width }, activeWidgets, onRemoveItem: parentRemoveItem, dragEnabled, toggleDrag, layouts: propsLayouts, setLayouts: propsSetLayouts, onLayoutChange: propsOnLayoutChange }) {
  
  const [items, setItems] = useState(activeWidgets);
  const [layouts, setLayouts] = useState(propsLayouts);
  
  // Update layouts when props change
  useEffect(() => {
    setLayouts(propsLayouts);
  }, [propsLayouts]);
  
  // Update items when activeWidgets change
  useEffect(() => {
    setItems(activeWidgets);
  }, [activeWidgets]);

const getCurrentBreakpoint = (width) => {
  if (width >= 1200) return 'lg';
  if (width >= 996) return 'md';
  if (width >= 768) return 'sm';
  if (width >= 480) return 'xs';
  return 'xxs';
};

const onLayoutChange = (_, allLayouts) => {
  const breakpoint = getCurrentBreakpoint(width);
  
  // Bei mobilen Breakpoints: ignoriere automatische Layout-Änderungen
  if (breakpoint !== 'lg' && breakpoint !== 'md') {
    return;
  }
  
  setLayouts(allLayouts);
  saveToLS("layouts", allLayouts);
};

const getCurrentLayout = () => {
  const savedLayouts = getFromLS("layouts");
  
  return activeWidgets.reduce((acc, widget) => {
    let widgetLayout;

    // Check which preset matches the current activeWidgets
    const isProductLayout = ["b","c","g","i","k","t"].every(item => activeWidgets.includes(item)) &&
                            activeWidgets.every(item => ["b","c","g","i","k","t"].includes(item));
    
    const isPrivateLayout = ["d","e","f","j","p","r","s","u"].every(item => activeWidgets.includes(item)) &&
                            activeWidgets.every(item => ["d","e","f","j","p","r","s","u"].includes(item));
    
    const isMaterialLayout = ["l","a","v"].every(item => activeWidgets.includes(item)) &&
                             activeWidgets.every(item => ["l","a","v"].includes(item));
    
    const isAboutLayout = ["m","n"].every(item => activeWidgets.includes(item)) &&
                          activeWidgets.every(item => ["m","n"].includes(item));
    
    const isPrivacyLayout = ["o"].every(item => activeWidgets.includes(item)) &&
                            activeWidgets.every(item => ["o"].includes(item));

    const isExactPresetMatch = isProductLayout || isPrivateLayout || isMaterialLayout || isAboutLayout || isPrivacyLayout;

    // First try to get layout from saved layouts if they exist
    if (savedLayouts && savedLayouts.lg) {
      const savedWidget = savedLayouts.lg.find(layout => layout.i === widget);
      
      if (savedWidget) {
        // If we're not in an exact preset match, always use saved layouts
        if (!isExactPresetMatch) {
          widgetLayout = savedWidget;
        } else {
          // If we're in an exact preset match, only use saved if ALL widgets have saved positions
          const allWidgetsSaved = activeWidgets.every(w => 
            savedLayouts.lg.some(l => l.i === w)
          );
          if (allWidgetsSaved) {
            widgetLayout = savedWidget;
          }
        }
      }
    }

    // If no saved layout found, use preset layouts
    if (!widgetLayout) {
      if (isProductLayout) {
        widgetLayout = initialLayoutsProduct.lg.find(layout => layout.i === widget);
      } 
      else if (isPrivateLayout) {
        widgetLayout = initialLayoutsPrivate.lg.find(layout => layout.i === widget);
      }
      else if (isMaterialLayout) {
        widgetLayout = initialLayoutsMaterial.lg.find(layout => layout.i === widget);
      }
      else if (isAboutLayout) {
        widgetLayout = initialLayoutsAbout.lg.find(layout => layout.i === widget);
      }
      else if (isPrivacyLayout) {
        widgetLayout = initialLayoutsPrivacy.lg.find(layout => layout.i === widget);
      }
      else {
        // Default to initialLayouts for "All" or any other combination
        widgetLayout = initialLayouts.lg.find(layout => layout.i === widget);
      }
    }

    if (widgetLayout) {
      acc.push(widgetLayout);
    }
    return acc;
  }, []);
};

const applyHeightMultiplier = (layout, breakpoint) => {
  return layout.map(item => {
    const multiplier = heightMultipliers[item.i]?.[breakpoint] || 1;
    return {
      ...item,
      h: Math.floor(item.h * multiplier)
    };
  });
};

const mergeWithComputed = (saved, computed) => {
  if (!saved || saved.length === 0) return computed;
  return computed.map(item => {
    const savedItem = saved.find(l => l.i === item.i);
    return (savedItem && savedItem.w > 0 && savedItem.h > 0) ? savedItem : item;
  });
};

  const onLayoutSave = () => {
    saveToLS("layouts", layouts);
  };

const onAddItem = (itemId) => {
  setItems(prev => prev.includes(itemId) ? prev : [...prev, itemId]);

  // Hole gespeicherte Layouts
  const savedLayouts = getFromLS("layouts") || {};
  const currentLayouts = layouts;

  // Finde das Widget in ALLEN möglichen Quellen
  let baseLgLayout = null;

  // 1. Versuche aus gespeicherten Layouts
  if (savedLayouts.lg) {
    baseLgLayout = savedLayouts.lg.find(l => l.i === itemId);
  }

  // 2. Falls nicht gespeichert, aus Presets holen
  if (!baseLgLayout) {
    const newItems = [...items, itemId];
    
    const isProductLayout = ["b","c","g","i","k","t"].every(item => newItems.includes(item)) &&
                            newItems.every(item => ["b","c","g","i","k","t"].includes(item));
    
    const isPrivateLayout = ["d","e","f","j","p","r","s","u"].every(item => newItems.includes(item)) &&
                            newItems.every(item => ["d","e","f","j","p","r","s","u"].includes(item));
    
    const isMaterialLayout = ["l","a","v"].every(item => newItems.includes(item)) &&
                             newItems.every(item => ["l","a","v"].includes(item));
    
    const isAboutLayout = ["m","n"].every(item => newItems.includes(item)) &&
                          newItems.every(item => ["m","n"].includes(item));
    
    const isPrivacyLayout = ["o"].every(item => newItems.includes(item)) &&
                            newItems.every(item => ["o"].includes(item));

    if (isProductLayout) {
      baseLgLayout = initialLayoutsProduct.lg.find(l => l.i === itemId);
    } else if (isPrivateLayout) {
      baseLgLayout = initialLayoutsPrivate.lg.find(l => l.i === itemId);
    } else if (isMaterialLayout) {
      baseLgLayout = initialLayoutsMaterial.lg.find(l => l.i === itemId);
    } else if (isAboutLayout) {
      baseLgLayout = initialLayoutsAbout.lg.find(l => l.i === itemId);
    } else if (isPrivacyLayout) {
      baseLgLayout = initialLayoutsPrivacy.lg.find(l => l.i === itemId);
    } else {
      baseLgLayout = initialLayouts.lg.find(l => l.i === itemId);
    }
  }

  // Fallback
  if (!baseLgLayout) {
    baseLgLayout = { i: itemId, x: 0, y: Infinity, w: 2, h: 30, minW: 2, maxW: 12, minH: 23, maxH: 1600 };
  }

const getSavedOrCalculated = (breakpoint, calculatedLayout) => {
  const saved = currentLayouts[breakpoint]?.find(l => l.i === itemId) || 
                savedLayouts[breakpoint]?.find(l => l.i === itemId);
  
  // NUR verwenden wenn w und h GRÖSSER als 0!
  if (saved && saved.w > 0 && saved.h > 0) {
    return saved;
  }
  return calculatedLayout;
};

// Erstelle multiplizierte Versionen
const mdLayout = { ...baseLgLayout };
const smLayout = { 
  ...baseLgLayout, 
  x: 0, 
  w: 6, 
  maxW: 6,
  h: Math.floor(baseLgLayout.h * (heightMultipliers[itemId]?.sm || 1))
};
const xsLayout = { 
  ...baseLgLayout, 
  x: 0, 
  w: 4, 
  maxW: 4,
  h: Math.floor(baseLgLayout.h * (heightMultipliers[itemId]?.xs || 2))
};
const xxsLayout = { 
  ...baseLgLayout, 
  x: 0, 
  w: 2, 
  maxW: 2,
  h: Math.floor(baseLgLayout.h * (heightMultipliers[itemId]?.xxs || 2.5))
};

// Filter alte Version raus
const filterOut = (arr) => (arr || []).filter(l => l.i !== itemId);

// ALLE Breakpoints updaten
const updatedLayouts = {
  lg: [...filterOut(currentLayouts.lg || savedLayouts.lg || []), baseLgLayout],
  md: [...filterOut(currentLayouts.md || savedLayouts.md || []), getSavedOrCalculated('md', mdLayout)],
  sm: [...filterOut(currentLayouts.sm || savedLayouts.sm || []), getSavedOrCalculated('sm', smLayout)],
  xs: [...filterOut(currentLayouts.xs || savedLayouts.xs || []), getSavedOrCalculated('xs', xsLayout)],
  xxs: [...filterOut(currentLayouts.xxs || savedLayouts.xxs || []), getSavedOrCalculated('xxs', xxsLayout)]
};

  setLayouts(updatedLayouts);
  saveToLS("layouts", updatedLayouts);
};
  
  const handleRemoveItem = (itemId) => {
    // Get current layouts
    const currentLayouts = getFromLS("layouts") || layouts;
    
    // Remove the item but keep layouts of remaining items
    const updatedLayouts = {
      lg: currentLayouts.lg?.filter(layout => layout.i !== itemId) || [],
    md: currentLayouts.md?.filter(layout => layout.i !== itemId) || [],
    sm: currentLayouts.sm?.filter(layout => layout.i !== itemId) || [],
    xs: currentLayouts.xs?.filter(layout => layout.i !== itemId) || [],
    xxs: currentLayouts.xxs?.filter(layout => layout.i !== itemId) || []
  };
    // Save updated layouts
    saveToLS("layouts", updatedLayouts);
    setLayouts(updatedLayouts);
    setItems(items.filter(i => i !== itemId));
    parentRemoveItem(itemId);
  };

  const heightMultipliers = {
  a: { sm: 1, xs: 13.5, xxs: 20},//"Fungi Studies
  b: { sm: 1, xs: 13, xxs: 10.75 },//"Remember Me
  c: { sm: 1, xs: 1.5, xxs: 2 },//"WRK",
  d: { sm: 1, xs: 2.1, xxs: 2.1 },//"INK",
  e: { sm: 1, xs: 6, xxs: 3 },//"Skizzen",
  f: { sm: 1, xs: 1, xxs: 1 },// "Framed Fluids",
  g: { sm: 1, xs: 4, xxs: 3},//"Rocking horse",
  h: { sm: 1, xs: 0.2, xxs: 0.2 }, //Layering
  i: { sm: 1, xs: 5, xxs: 5},//Opener
  j: { sm: 1, xs: 14, xxs: 14 },//The Microcosm
  k: { sm: 1, xs: 6.75, xxs: 6.75 },//Bottle
  l: { sm: 1, xs: 20, xxs: 25.5},//Scoby Samples
  m: { sm: 1, xs: 5, xxs: 7 },//My Workflow
  n: { sm: 1, xs: 1, xxs: 0.9 },//me/Contact
  o: { sm: 2, xs: 2.5, xxs: 3 },//
  p: { sm: 1, xs: 4.6, xxs: 4.8},//Airship Animation
  r: { sm: 1, xs: 2.5, xxs: 2.5 },//Instrument Posters
  s: { sm: 1, xs: 2.85, xxs: 2.85 },//Other Animations
  t: { sm: 1, xs: 4, xxs: 4 },// "Lampshade",
  u: { sm: 1, xs: 3, xxs: 3},//"Isaac",
  v: { sm: 1, xs: 7, xxs: 7}//"Plastic Samples"
};
  
  return (
    <>
      <TopBar
        onLayoutSave={onLayoutSave}
        items={items}
        onRemoveItem={handleRemoveItem}
        onAddItem={onAddItem}
        originalItems={originalItems}
      />
      
 <ResponsiveGridLayout
  className="layout"
  layouts={{
    lg: getCurrentLayout(),
    md: mergeWithComputed(layouts.md, applyHeightMultiplier(getCurrentLayout(), 'md')),
    sm: mergeWithComputed(layouts.sm, applyHeightMultiplier(getCurrentLayout(), 'sm')),
    xs: mergeWithComputed(layouts.xs, applyHeightMultiplier(getCurrentLayout(), 'xs')),
    xxs: mergeWithComputed(layouts.xxs, applyHeightMultiplier(getCurrentLayout(), 'xxs'))
  }}
  breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
  cols={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }}
  rowHeight={3}
  width={width}
  onLayoutChange={onLayoutChange}
  onResizeStop={(layout, oldItem, newItem) => {
    const breakpoint = getCurrentBreakpoint(width);
    
    // Speichere das AKTUELLE Layout für den aktuellen Breakpoint
    let updatedLayouts = { ...layouts };
    
    if (breakpoint === 'lg' || breakpoint === 'md') {
      // Bei lg/md: direkt speichern
      updatedLayouts[breakpoint] = layout;
    } else {
      // Bei sm/xs/xxs: Multiplier zurückrechnen für lg, aber auch aktuelles Layout speichern
      const correctedLgLayout = layout.map(item => {
        if (item.i === newItem.i) {
          const multiplier = heightMultipliers[item.i]?.[breakpoint] || 1;
          return {
            ...item,
            h: Math.round(item.h / multiplier)
          };
        }
        return item;
      });
      
      updatedLayouts.lg = correctedLgLayout;
      updatedLayouts[breakpoint] = layout; // Speichere auch das multiplizierte Layout
    }
    
    setLayouts(updatedLayouts);
    saveToLS("layouts", updatedLayouts);
  }}
  onDragStop={(layout, oldItem, newItem) => {
    const breakpoint = getCurrentBreakpoint(width);
    
    // Speichere Position für aktuellen Breakpoint
    let updatedLayouts = { ...layouts };
    updatedLayouts[breakpoint] = layout;
    
    // Aktualisiere auch lg mit neuen Positionen
    if (breakpoint !== 'lg' && breakpoint !== 'md') {
      const updatedLgLayout = getCurrentLayout().map(item => {
        const movedItem = layout.find(l => l.i === item.i);
        if (movedItem) {
          return { ...item, x: movedItem.x, y: movedItem.y };
        }
        return item;
      });
      updatedLayouts.lg = updatedLgLayout;
    }
    
    setLayouts(updatedLayouts);
    saveToLS("layouts", updatedLayouts);
  }}
  draggableHandle={dragEnabled ? ".dragHandle" : ""}
  resizableHandle={dragEnabled ? ".resizeHandle" : ""}
  useCSSTransforms={true}
  compactType="vertical">
        {activeWidgets.map((key) => (
          <div
            key={key}
            className={`widget widget-${key}`} 
            data-grid={initialLayouts.lg.find(l => l.i === key) || { w: 2, h: 30, x: 0, y: Infinity }}
            static={!dragEnabled}
          >
            <Widget
              id={key}
              onRemoveItem={handleRemoveItem}
              backgroundColor={key === 'a' ? '#ececec' 
                : key === 'b' ? '#ececec'
                : key === 'c' ? '#ececec' 
                : key === 'd' ? '#373737' 
                : key === 'e' ? '#373737' 
                : key === 'f' ? '#373737' 
                : key === 'g' ? '#ececec' 
                : key === 'h' ? '#ececec' 
                : key === 'i' ? '#ececec' 
                : key === 'j' ? '#373737' 
                : key === 'k' ? '#ececec' 
                : key === 'l' ? '#ececec'   
                : key === 'm' ? '#373737' 
                : key === 'p' ? '#373737'
                : key === 't' ? '#ececec'
                : key === 'v' ? '#ececec'
                : '#373737'} 
              deleteButtonColor={key === "a" ? '#373737' 
                : key === 'b' ? '#373737' 
                : key === 'c' ? '#373737' 
                : key === 'd' ? '#FFFFFF' 
                : key === 'e' ? '#FFFFFF' 
                : key === 'f' ? '#FFFFFF' 
                : key === 'g' ? '#373737' 
                : key === 'h' ? '#373737' 
                : key === 'i' ? '#373737' 
                : key === 'j' ? '#FFFFFF' 
                : key === 'k' ? '#373737' 
                : key === 'l' ? '#373737'
                : key === 'm' ? '#FFFFFF'
                : key === 'p' ? '#FFFFFF'
                : key === 't' ? '#373737'
                : key === 'v' ? '#373737'
                : '#FFFFFF'} 
              infoButtonColor={key === "a" ? '#373737' 
                : key === 'b' ? '#373737' 
                : key === 'c' ? '#373737' 
                : key === 'd' ? '#FFFFFF' 
                : key === 'e' ? '#FFFFFF' 
                : key === 'f' ? '#FFFFFF' 
                : key === 'g' ? '#373737' 
                : key === 'h' ? '#373737' 
                : key === 'i' ? '#373737' 
                : key === 'j' ? '#FFFFFF' 
                : key === 'k' ? '#373737' 
                : key === 'l' ? '#373737'
                : key === 'm' ? '#FFFFFF'
                : key === 'p' ? '#FFFFFF'
                 : key ==='t' ? '#373737'
                : key === 'v' ? '#373737'
                : '#FFFFFF'}
            />
            <div className="dragHandle"></div>
            <div className="resizeHandle"></div>
          </div>
        ))}
      </ResponsiveGridLayout>
    </>
  );
}

export default withSize({ refreshMode: "debounce", refreshRate: 60 })(Content);

// Keep existing helper functions
function getFromLS(key) {
  let ls = {};
  if (global.localStorage) {
    try {
      ls = JSON.parse(global.localStorage.getItem("rgl-8")) || {};
    } catch (e) { }
  }
  return ls[key];
}

function saveToLS(key, value) {
  if (global.localStorage) {
    global.localStorage.setItem(
      "rgl-8",
      JSON.stringify({
        [key]: value
      })
    );
  }
}